import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { LocalStorageService } from "./local-storage.service";

/**
 * The single method here is a route guard which prevents not logged in users from accessing pages.
 */
@Injectable({
    providedIn: 'root',
  })
export class RouteGuard  {


    constructor(private dataSync: LocalStorageService, private router: Router) {}

    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Promise<boolean|UrlTree> {
        return new Promise<boolean|UrlTree>((resolve) => {
          this.dataSync.local_storage.get('login_status').then((doc: any) => {
            resolve(doc.isLoggedIn ? true : this.router.parseUrl('login'));
          })
        });
         
    }
  }
